// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import AuthWrapper from './components/AuthWrapper'
// Amplify configuration removed - now using BFF authentication pattern

createRoot(document.getElementById('root')!).render(
    <Router>
      <AuthWrapper>
        <App />
      </AuthWrapper>
    </Router>
)
